// taken from gatsby source code
import React from 'react';
import {Location} from '@reach/router';

const withLocation = (Comp) => (props) => (
  <Location>{(location) => <Comp {...location} {...props} />}</Location>
);

export default withLocation;
